import {dateFormatterDDMMMYYY, getImageFromFilesbyKey, SecondsToMinutes} from "../../../../_metronic/_helpers";

export const parseSliderParams = (item, image = "imgPortrait") => {
    let {background, title, textLeft, textRight, callbackUrl, type_id} = "";
    if (!!item.title) {
        background = item.files && item.files.length !== 0 && getImageFromFilesbyKey(item.files, item.id, image, item.type_id);
        title = item.title;
        textLeft = item.created_at && dateFormatterDDMMMYYY(item.created_at);
        textRight =
            item.duration && typeof item.duration === "number" ? SecondsToMinutes(item.duration) + " mins" : null;
        callbackUrl = `/media/${item.id}`;
        type_id = item.type_id;
    } else {
        background = item.picture;
        title = item.name;
        textLeft = item.created_at && dateFormatterDDMMMYYY(item.created_at);
        textRight = "";
        callbackUrl = `/track/${item.track_id}`;
    }
    return {background, title, textLeft, textRight, callbackUrl, type_id};
};
